import { useCallback, useMemo, useRef, useState } from 'react';
import { useIsomorphicLayoutEffect, useResizeListener } from '@direct-frontend/stdlib';
import { chain } from 'react-aria';

function getFullyScrolled(element: Element) {
    return element.scrollTop + element.clientHeight >= element.scrollHeight - 1;
}

export const useIsFullyScrolled = function () {
    const ref = useRef<HTMLDivElement | null>(null);

    const [isFullyScrolled, setIsFullyScrolled] = useState(false);

    const updateBorderVisible = useCallback((element: Element) => {
        const isFullyScrolled = getFullyScrolled(element);
        setIsFullyScrolled(isFullyScrolled);
    }, []);

    const setResizeRef = useResizeListener(([entry]) => {
        if (!entry) {
            return;
        }

        updateBorderVisible(entry.target);
    });

    const refCallback = useMemo(
        // eslint-disable-next-line react-hooks/refs -- Автоматический игнор в рамках DIRECT-288723
        () => chain(setResizeRef, (node: HTMLDivElement) => (ref.current = node)),
        [setResizeRef],
    );

    const onScroll = useCallback(() => {
        if (!ref.current) {
            return;
        }

        updateBorderVisible(ref.current);
    }, [updateBorderVisible]);

    // useResizeListener не вызывает колбэк при создании обсервера, поэтому первое значение размера получаем сами
    useIsomorphicLayoutEffect(() => {
        if (ref.current) {
            updateBorderVisible(ref.current);
        }
    }, []);

    return {
        ref: refCallback,
        onScroll,
        isFullyScrolled,
    };
};
